import { AUTH_URL } from "../../urls.api";

export const ME_URL = `${AUTH_URL}/me`;
